export default ({ request }) => ({
  thdapiOaFailureRecordListApi(data = {}) {
    return request({
      url: '/master/thdapiOaFailureRecord/list',
      method: 'post',
      data
    })
  },
  thdapiOaFailureRecordDetailApi(data = {}) {
    return request({
      url: '/master/thdapiOaFailureRecord/detail',
      method: 'post',
      data
    })
  }
})
